// 個別機能訓練に関する記録・詳細(Show).
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as UserListField from '../constants/UserListField';
import { JS_VOID } from '../utils/commonUtil';
import * as KirokuConst from '../constants/Kiroku';
import { convertTime, convertDay } from '../utils/dateUtil';
import { Global } from '../utils/global';

const CRUD_EDIT: number = 1;

interface EleseProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  user: UserListField.User;
  filteredTraining: KirokuConst.Training[];
  crudType: number;
}

interface ElseState {
  checkDataArr: KirokuConst.CheckData[];
}

// その他コンポーネント.
export class Else extends React.Component<EleseProps, ElseState> {
  filteredTraining: KirokuConst.Training[];
  user: UserListField.User;

  componentWillMount() {
    this.user = this.props.user;
    this.filteredTraining = this.props.filteredTraining;

    // stateの準備.
    let tmp: KirokuConst.CheckData[] = [];
    this.filteredTraining.map((training: KirokuConst.Training, index: number) => {
      // ついでに日付をコンバート.
      let theday = convertTime(training.datetime).day;
      theday = convertDay(theday);
      training.day = theday;

      tmp.push({
        id: index,
        selected: true,
      } as KirokuConst.CheckData);
    });

    this.setState({
      checkDataArr: tmp,
    });
  }

  toKirokuEdit() {
    this.context.callbackParent(KirokuConst.type.Edit);
  }

  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  dellRecord(datetime: string) {
    if (window.confirm('データを削除してよろしいですか？')) {
      const userId: string = this.props.user.user_id;
      const timeTexConverted = convertTime(datetime);
      this.props.moffAPIActions.deleteFunctionalTrainingHistory(userId, timeTexConverted['ux-qa']);

      // 削除ステート.
      this.context.callbackParent(KirokuConst.type.Delete);
    } else {
      // 警告ダイアログを表示.
      window.alert('キャンセルされました');
    }
  }

  // チェックボックスの状況変更.
  changeSelection(id: number) {
    const nextState = this.state.checkDataArr.map(function (checkData: KirokuConst.CheckData) {
      return {
        id: checkData.id,
        selected: (checkData.id === id ? !checkData.selected : checkData.selected)
      };
    });
  
    this.setState({checkDataArr: nextState});
  }

  render() {
    const dustBoxImg: string = require('../common/img/dustbox.png');

    // ゴミ箱ボタン.
    let displayDeleteButton: boolean = true;

    return (
      <div>
        <table className="tblStyle00">
          <thead>
            <tr>
              { Global.isApp ?
                <th scope="col" className="isApp" />
                :
                <th scope="col">印刷<br />対象</th>
              }
              <th scope="col">実施日時</th>
              <th scope="col">実施時間</th>
              <th scope="col">訓練内容</th>
              <th scope="col">機能訓練<br />指導員</th>
              <th scope="col">特記事項</th>
              <th scope="col">削除</th>
            </tr>
          </thead>

          <tbody>
            {
              this.filteredTraining.map((training: KirokuConst.Training, index: number) => {
                return (
                  <tr
                    key={index}
                    className={this.state.checkDataArr[index].selected ? 'Print' : ''}
                  >
                    { Global.isApp ?
                      <td />
                      :
                      <td>
                        <input
                          type="checkbox"
                          checked={this.state.checkDataArr[index].selected}
                          onChange={this.changeSelection.bind(this, index)}
                        />
                      </td>
                    }
                    <td>{training.day}</td>
                    <td>{training.duration}</td>
                    <td>{training.subject}</td>
                    <td>{training.instructor}</td>
                    <td>{training.remarks}</td>
                    { displayDeleteButton ?
                      <td>
                        <img
                          onClick={event => this.dellRecord(training.datetime)}
                          src={dustBoxImg}
                          alt="データ削除"
                          width="90%"
                          className="deletebutton"
                        />
                      </td>
                      :
                      (false)
                    }
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        {
          (() => {
            if (this.props.crudType === CRUD_EDIT) {
            // あとで切り替え.
            return <div className="edit-btn btnStyle00">
              <a
                role="button"
                onClick={_ => this.toKirokuEdit()}
              >
                編集
              </a>
            </div>;
            } else {
              return (null);
            }
          })()
        }
      </div>
    );
  }
}

export class DummyKirokuShow extends React.Component {
  render() {
    return (
      <div>
        <p>読み込み中</p>
      </div>
    );
  }
}

interface KirokuShowProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  user: UserListField.User;
  filteredTraining: KirokuConst.Training[];
}

interface KirokuSHowState {
}

// 詳細本体.
export default class KirokuShow extends React.Component<KirokuShowProps, KirokuSHowState> {
  user: UserListField.User;
  filteredTraining: KirokuConst.Training[];

  componentWillMount() {
    this.user = this.props.user;
    this.filteredTraining = this.props.filteredTraining;
  }

  toKirokuEdit() {
    this.context.callbackParent(KirokuConst.type.Edit);
  }

  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  render() {
    let dataNullFlg: number = 0;
    if (this.filteredTraining) {
      dataNullFlg = this.filteredTraining.length;
    }

    if (dataNullFlg === 0) {
      return (
        <div>
          <p>この月はデータがありません。</p>
          <div className="edit-btn btnStyle00">
            <a
              href={JS_VOID}
              role="button"
              onClick={_ => this.toKirokuEdit()}
            > 
              編集  
            </a>
          </div>
        </div>
      );
    } else {
      return (
        <Else
          moffAPI={this.props.moffAPI}
          moffAPIActions={this.props.moffAPIActions}
          user={this.user}
          filteredTraining={this.filteredTraining}
          crudType={CRUD_EDIT}
        />
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/KirokuShow.tsx